import axios from 'axios';
import { showError } from './errorHandler';

const BACKEND_URL = process.env.REACT_APP_API_URL;

// すべてのリクエストでクッキーを送信するようにデフォルト設定
axios.defaults.withCredentials = true;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// axiosのレスポンスインターセプターを設定
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 401エラーで、かつまだリトライしていない場合
    if (error.response?.status === 401 && !originalRequest._retry) {
      // ログインページの場合、ルートパスの場合、またはインターセプターをスキップする指定がある場合はリフレッシュを試みない
      if (window.location.pathname === '/login' || window.location.pathname === '/' || originalRequest._skipInterceptor) {
        return Promise.reject(error);
      }

      // リフレッシュ中の場合、キューに追加
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => {
          return axios(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log('Token expired, attempting refresh...');

        // リフレッシュトークンを使ってアクセストークンを更新
        // クッキーベース認証なので、サーバーが自動的に新しいクッキーを設定する
        await axios.post(
          `${BACKEND_URL}/auth/refresh`,
          {},
          {
            withCredentials: true,
            // この呼び出しはインターセプターの対象外にする
            _isRefreshRequest: true
          }
        );

        console.log('Token refresh successful');

        // キューの処理
        processQueue(null);
        isRefreshing = false;

        // 元のリクエストを再実行
        return axios(originalRequest);

      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);

        // リフレッシュが失敗した場合はログアウト処理
        processQueue(refreshError, null);
        isRefreshing = false;

        // ストレージをクリア（念のため）
        localStorage.clear();
        sessionStorage.clear();

        // ユーザーフレンドリーなメッセージを表示
        showError(null, 'ログインの有効期限が切れました\n\n5秒後にログインページに移動します');

        // 5秒後にログインページにリダイレクト
        console.log('Redirecting to login page in 5 seconds...');
        setTimeout(() => {
          if (window.location.pathname !== '/login') {
            console.log('Performing redirect to login');
            window.location.replace('/login');
          }
        }, 5000);

        return Promise.reject(refreshError);
      }
    }

    // その他のエラーもユーザーフレンドリーに処理
    // ただし、ログインページやリフレッシュリクエストの場合は表示しない
    if (window.location.pathname !== '/login' && !originalRequest._isRefreshRequest) {
      // エラーの種類によって表示を制御
      if (error.response?.status === 403) {
        showError(error);
      } else if (error.response?.status >= 500) {
        showError(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axios; 